import { Button } from '@mantine/core';
import { DataTable } from 'mantine-datatable';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDuplicateContact } from 'src/Hooks/Mutations/useDuplicateContact';
import { useFetchAssets } from 'src/Hooks/Queries/useFetchAssets';
import { AssetPreviewDto } from 'src/Services/API/generated';

import styles from './DuplicateContactModalContent.module.scss';
import { Props } from './DuplicateContactModalContent.types';

// t('contacts.duplicateModal.duplicate_one', 'Dupliquer')
// t('contacts.duplicateModal.duplicate_other', 'Dupliquer')
// t('contacts.duplicateModal.duplicate_one', 'Dupliquer dans {{count}} bien')
// t('contacts.duplicateModal.duplicate_other', 'Dupliquer dans {{count}} biens')
// t('contacts.duplicateModal.duplicate_zero', 'Sélectionnez au moins un bien')

const DuplicateContactModalContent = ({ context, id, innerProps }: Props) => {
  const { t } = useTranslation();
  const { data: assets, isLoading: assetLoading } = useFetchAssets();
  const { mutate: duplicate, isLoading: duplicateLoading } = useDuplicateContact(
    innerProps.currentAssetId,
    { onSuccess: () => context.closeModal(id) }
  );

  const [selectedAssets, setSelectedAssets] = useState([] as AssetPreviewDto[]);

  const filteredAssets = useMemo(
    () => assets?.filter(asset => asset.id !== innerProps.currentAssetId) ?? [],
    [assets, innerProps.currentAssetId]
  );

  return (
    <>
      <DataTable
        withRowBorders={false}
        selectedRecords={selectedAssets}
        onSelectedRecordsChange={setSelectedAssets}
        records={filteredAssets}
        noRecordsText={t('contacts.duplicateModal.empty', 'Aucun autre bien')}
        fetching={assetLoading || innerProps.currentAssetId === undefined}
        columns={[{ accessor: 'name', title: t('contacts.duplicateModal.name', 'Nom') }]}
        noHeader
      />
      <div className={styles.actions}>
        <Button variant="outline" onClick={() => context.closeModal(id)}>
          {t('contacts.duplicateModal.cancel', 'Annuler')}
        </Button>
        <Button
          disabled={selectedAssets.length === 0}
          loading={duplicateLoading}
          onClick={() =>
            duplicate({
              contactId: innerProps.contactId,
              targetAssetIds: selectedAssets.map(asset => asset.id),
            })
          }
        >
          {t('contacts.duplicateModal.duplicate', { count: selectedAssets.length })}
        </Button>
      </div>
    </>
  );
};

export default DuplicateContactModalContent;
